const state = {
  proceedContainerNext: "",
 
};
const mutations = {
  SET_VALID_CONTAINER: (state, payload) => {
    state.proceedContainerNext = payload;
  },
};

const actions = {
  setContainerList({
    commit
  }, payload) {
    commit("SET_VALID_CONTAINER", payload);
  },
  

};
const getters = {
  storeProceedContainer: state => state.proceedContainerNext,
};
export default {
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/module/containerValid.js